module.exports = __webpack_public_path__ + "static/media/image_keyword_01.ef6ba081.webp";